import { Component, OnInit, Input } from '@angular/core';
import {DialogService} from '@rbaip/ui-component';
import {
  ASSET_STATUS_CONTRACT_READY,
  ASSET_STATUS_INFO_COMPLETE,
  ASSET_STATUS_MISSING_INFO,
  RBA_LIVE,
  AssetStatus, assetMessage, AssetSaleInfo, assetMoveErrorCodes, Asset, AuditAssetMove, RETURN_TO_PREVIOUS_SALE,
} from '../../../shared/domain/item';
import { MOVE_ASSET_INTO_AUCTION_EVENT, MOVE_ASSET_BACK_TO_OPPORTUNITY,
  MOVE_ASSET_INTO_HOLDING_PEN, MOVE_ASSET_INTO_OTHER_OPPORTUNITY, MOVE_ASSET_INTO_OTHER_CONTRACT, MOVE_ASSET_BACK_TO_WIP
} from '../../../shared/domain/item';
import { MatDialogRef } from '@angular/material/dialog';
import {Observable} from 'rxjs';
import { MoveAssetsComponent } from '../move-assets.component';
import {AssetPackageDto} from '../../../shared/domain/asset-package';
import {ItemSummaryAssetControlGroupService} from '../../../shared/asset-package/item-summary-asset-control-group.service';
import {ItemSummaryAssetsService} from '../../../shared/asset/item-summary-assets.service';


@Component({
  selector: 'lib-item-summary-asset-move-reason',
  templateUrl: './asset-move-reason.component.html',
  styleUrls: ['./asset-move-reason.component.scss']
})
export class AssetMoveReasonComponent implements OnInit {

  @Input() auditAssetMove: AuditAssetMove;
  @Input() assets: Asset[];
  @Input() contractId: number;

  public isMoveInProgress = false;

  private currentAssetControlGroup: AssetPackageDto;
  private sendToOperations = 'N';
  private moveReasonValid = false;

  constructor(private assetsService: ItemSummaryAssetsService,
              private assetControlGroupService: ItemSummaryAssetControlGroupService,
              private dialogRef: MatDialogRef<MoveAssetsComponent>,
              private dialogService: DialogService) { }

  ngOnInit() {
    this.getCurrentAssetPackageInfo();
    this.setTargetOpportunityIfMissed();
  }

  public isMoveReasonValid(valid): void {
    this.moveReasonValid = valid;
  }

  public isFormValid(): boolean {
    return this.moveReasonValid;
  }

  public getMoveButtonLabel(): string {
    if ( this.isPullingLots() ) {
      return 'Pull Lot';
    } else {
      return 'Move';
    }
  }

  public pullLotFromSale(): void {
    if (!this.moveReasonValid) {
      return;
    } else {
      this.isMoveInProgress = true;
      this.dialogService.showMessageDialog(assetMessage.assetMoveConfirmation)
        .afterClosed().subscribe(response => {
        if (response) {
          this.initiateMove();
        } else {
          this.isMoveInProgress = false;
        }
      });
    }
  }

  private initiateMove(): void {
    let additionalHaulingBudget = 0;
    let additionalRnRBudget = 0;
    this.dialogService.showProgress();
    // Set Pull reason details on assets
    this.assets.forEach(asset => {
      asset.auditAssetMove = ( JSON.parse( JSON.stringify( this.auditAssetMove ) ) );
      asset.auditAssetMove.assetId = asset.assetId;
      asset.auditAssetMove.equipId = asset.equipId;
      // treat move to previous sale same as move to auction event
      if ( asset.auditAssetMove && asset.auditAssetMove.destinationType === RETURN_TO_PREVIOUS_SALE ){
        asset.auditAssetMove.destinationType = MOVE_ASSET_INTO_AUCTION_EVENT;
      }
      additionalHaulingBudget = asset.haulingBudget ? ( additionalHaulingBudget + asset.haulingBudget ) : additionalHaulingBudget;
      additionalRnRBudget = asset.rnrBudget ? ( additionalRnRBudget + asset.rnrBudget ) : additionalRnRBudget;
    });
    // validate RnR/hauling budgets
    if ( !this.isTargetAcgBudgetsValid(additionalHaulingBudget, additionalRnRBudget) ) {
      this.dialogService.hideProgress();
      this.dialogService.showMessageDialog(assetMessage.budgetsExceededWarning)
        .afterClosed().subscribe(response => {
        if ( response ) {
          this.dialogService.showProgress();
          this.processAssets();
        }
      });
    } else {
      this.processAssets();
    }
  }


  private isTargetAcgBudgetsValid(additionalHaulingBudget: number, additionalRnRBudget: number): boolean {
    if (!this.auditAssetMove.targetAssetControlGroup) {
      return true;
    }
    const newHaulingBudget = this.auditAssetMove.targetAssetControlGroup.haulingBudgetRollup + additionalHaulingBudget;
    const newRnRBudget = this.auditAssetMove.targetAssetControlGroup.rnrBudgetRollup + additionalRnRBudget;
    if (this.auditAssetMove.targetAssetControlGroup.haulingBudgetLimit && this.auditAssetMove.targetAssetControlGroup.haulingBudgetLimit < newHaulingBudget) {
      return false;
    }
    if (this.auditAssetMove.targetAssetControlGroup.rnrBudgetLimit && this.auditAssetMove.targetAssetControlGroup.rnrBudgetLimit < newRnRBudget) {
      return false;
    }
    return true;
  }

  private processAssetsForMovingToOtherContract(): void {
    let isRequiredSaleInfoPresent = false;
    let hasPreSaleAssets = false;
    this.assets.forEach(asset => {
      if ( !AssetStatus.isPostSaleStatus(asset.assetStatusId) ) {
        hasPreSaleAssets = true;
      }
      const assetSaleInfo = AssetSaleInfo.getSaleInfoFromAsset(asset, this.currentAssetControlGroup);
      if ( assetSaleInfo.isValid() ) {
        isRequiredSaleInfoPresent = true;
      }
    });
    if ( isRequiredSaleInfoPresent && hasPreSaleAssets ) {
      let assetsEligibleForContracts = this.assets;
      if ( assetsEligibleForContracts && this.auditAssetMove.targetAssetControlGroup
        && !this.auditAssetMove.targetAssetControlGroup.isContractSigned ) {
        assetsEligibleForContracts = assetsEligibleForContracts.filter(asset => asset.saleType === RBA_LIVE);
      }
      if ( assetsEligibleForContracts && assetsEligibleForContracts.length > 0 ) {
        this.dialogService.showMessageDialog(assetMessage.assetSendToOperationsConfirmation)
          .afterClosed().subscribe(response => {
          if ( response ) {
            this.assets.forEach(asset => {
              this.sendToOperations = 'Y';
            });
            this.getAndProcessObservable();
          } else {
            this.auditAssetMove.destinationType = MOVE_ASSET_INTO_OTHER_OPPORTUNITY;
            this.processAssetsForMovingToOtherOpportunity();
          }
        });
      } else {
        this.getAndProcessObservable();
      }
    } else {
      this.getAndProcessObservable();
    }
  }

  private processAssetsForMovingToOtherOpportunity(): void {
    let isRequiredSaleInfoPresent = false;
    this.assets.forEach(asset => {
      const assetSaleInfo = AssetSaleInfo.getSaleInfoFromAsset(asset, this.currentAssetControlGroup);
      if ( assetSaleInfo.isValid() ) {
        isRequiredSaleInfoPresent = true;
        asset.assetStatusId = ASSET_STATUS_INFO_COMPLETE;
      } else {
        asset.assetStatusId = ASSET_STATUS_MISSING_INFO;
      }
    });
    if ( isRequiredSaleInfoPresent ) {
      this.dialogService.showMessageDialog(assetMessage.assetMoveToContractReadyConfirmation)
        .afterClosed().subscribe(response => {
        if (response) {
          this.assets.forEach(asset => {
            if (asset.assetStatusId === ASSET_STATUS_INFO_COMPLETE) {
              asset.assetStatusId = ASSET_STATUS_CONTRACT_READY;
            }
          });
        }
        this.getAndProcessObservable();
      });
    } else {
      this.getAndProcessObservable();
    }
  }

  private processAssetsForMovingToOtherEvent(): void {
    this.assets.forEach(asset => {
      const assetSaleInfo = AssetSaleInfo.getSaleInfoFromAsset(asset, this.currentAssetControlGroup);
      if (!asset.equipId) {
        if (assetSaleInfo.isValid()) {
          asset.assetStatusId = ASSET_STATUS_INFO_COMPLETE;
        } else {
          asset.assetStatusId = ASSET_STATUS_MISSING_INFO;
        }
      }
    });
    this.getAndProcessObservable();
  }

  private processAssets(): void {
    this.isMoveInProgress = true;
    if (this.auditAssetMove.destinationType === MOVE_ASSET_INTO_OTHER_OPPORTUNITY
          || this.auditAssetMove.destinationType === MOVE_ASSET_INTO_OTHER_CONTRACT
          || this.auditAssetMove.destinationType === MOVE_ASSET_INTO_AUCTION_EVENT) {
      if (this.assets.some(asset => Asset.isPendingAppraisal(asset))) {
        this.dialogService.hideProgress();
        let confirmAssetPendingAppraisal = assetMessage.confirmAssetPendingAppraisal;
        this.dialogService.showMessageDialog(confirmAssetPendingAppraisal)
          .afterClosed().subscribe(result => {
          if ( result === 'OK' ) {
            this.dialogService.showProgress();
            this.processMovePackageOrEventAction();
          } else {
            this.isMoveInProgress = false;
          }
        });
      } else {
        this.processMovePackageOrEventAction();
      }
    } else {
      this.getAndProcessObservable();
    }
  }

  private processMovePackageOrEventAction(): void {
    if (this.auditAssetMove.destinationType === MOVE_ASSET_INTO_OTHER_OPPORTUNITY) {
      this.processAssetsForMovingToOtherOpportunity();
    } else if (this.auditAssetMove.destinationType === MOVE_ASSET_INTO_OTHER_CONTRACT) {
      this.processAssetsForMovingToOtherContract();
    } else if (this.auditAssetMove.destinationType === MOVE_ASSET_INTO_AUCTION_EVENT) {
      this.processAssetsForMovingToOtherEvent();
    }
  }

  private getAndProcessObservable(): void {
    this.getObservableBasedOnDestinationType().subscribe( itemsResponse => {
      this.isMoveInProgress = false;
      if ( itemsResponse && itemsResponse.error ) {
        this.dialogService.showMessage(itemsResponse.message);
        this.dialogService.hideProgress();
      } else {
        let failedAssetsCount = 0;
        if ( itemsResponse ) {
          itemsResponse.forEach(itemResponse => {
            if ( itemResponse.status !== 'Success' ) {
              failedAssetsCount++;
            }
          });
        }
        if ( failedAssetsCount > 0 ) {
          let errorMessageObject = assetMessage.assetMoveError;
          if ( failedAssetsCount === 1 ) {
            if ( !!itemsResponse[0].errorCode && itemsResponse[0].errorCode === assetMoveErrorCodes.ownerCodeRetrievalError ) {
              errorMessageObject = assetMessage.assetMoveOwnerCodeError;
            } else {
              errorMessageObject.message = errorMessageObject.message.replace(':message', itemsResponse[0].message);
            }
          } else if ( failedAssetsCount > 1 ) {
            let message = failedAssetsCount + ' out of ' + itemsResponse.length +
              ' assets failed while pulling lots. Please contact tech support. ';
            if (failedAssetsCount === itemsResponse.length) {
              message = 'Unexpected error occurred while pulling lots. Please contact tech support. ';
            }
            errorMessageObject.message = errorMessageObject.message.replace(':message', message);
          }
          this.dialogService.showMessageDialog(errorMessageObject);
        } else {
          const message = this.isPullingLots() ? 'Lots successfully pulled.' : 'Lots successfully moved.';
          this.dialogService.showMessage(message);
          this.dialogRef.close(true);
        }
        this.dialogService.hideProgress();
      }
    } , error => {
      this.dialogService.showMessage('Unexpected error occurred while pulling lots. Please contact tech support. ');
      this.dialogService.hideProgress();
      this.isMoveInProgress = false;
    });
  }

  private getObservableBasedOnDestinationType(): Observable<any> {
    let pullLotObservable;
    switch (this.auditAssetMove.destinationType) {
      case MOVE_ASSET_BACK_TO_WIP:
        pullLotObservable = this.assetsService.moveAssetsBackToWip(this.assets);
        break;
      case MOVE_ASSET_INTO_OTHER_OPPORTUNITY:
        pullLotObservable = this.assetsService.moveAssetsToAnotherOpportunity(this.auditAssetMove.newOpportunityId, this.auditAssetMove.retainSaleInfo, this.assets);
        break;
      case MOVE_ASSET_BACK_TO_OPPORTUNITY:
        pullLotObservable = this.assetsService.moveAssetsBackToOpportunity(this.contractId, this.assets);
        break;
      case MOVE_ASSET_INTO_OTHER_CONTRACT:
        pullLotObservable = this.assetsService.moveAssetsToAnotherContract(this.auditAssetMove.newContractId, this.sendToOperations, this.auditAssetMove.retainSaleInfo, this.assets);
        break;
      case MOVE_ASSET_INTO_AUCTION_EVENT:
        pullLotObservable = this.assetsService.moveAssetsToAnotherEvent(this.currentAssetControlGroup.opportunityId, this.assets);
        break;
      case MOVE_ASSET_INTO_HOLDING_PEN:
        pullLotObservable = this.assetsService.moveAssetsToHoldingPen(this.assets);
        break;
      case RETURN_TO_PREVIOUS_SALE:
        pullLotObservable = this.assetsService.moveAssetsToAnotherEvent(this.currentAssetControlGroup.opportunityId, this.assets);
        break;
    }
    return pullLotObservable;
  }

  private getCurrentAssetPackageInfo(): void {
    const assetControlGroupId = this.assets[0].assetControlGroupId;
    this.assetControlGroupService.getAssetPackageInfo(assetControlGroupId).subscribe( assetControlGroup => {
      this.currentAssetControlGroup = assetControlGroup;
    });
  }

  private setTargetOpportunityIfMissed(): void {
    if ( !this.auditAssetMove.targetAssetControlGroup) {
      const opportunityContract = this.auditAssetMove.selectedContract ? this.auditAssetMove.selectedContract : this.auditAssetMove.selectedOpportunity;
      if (!opportunityContract || !opportunityContract.assetControlGroupId) {
        return ;
      }
      const assetControlGroupId = opportunityContract.assetControlGroupId;
      this.dialogService.showProgress();
      this.assetControlGroupService.getAssetPackageInfo(assetControlGroupId).subscribe(assetControlGroup => {
        this.auditAssetMove.targetAssetControlGroup = assetControlGroup;
        this.dialogService.hideProgress();
      });
    }
  }

  private isPullingLots(): boolean {
    return this.auditAssetMove.destinationType ===  MOVE_ASSET_BACK_TO_OPPORTUNITY ||
      this.auditAssetMove.destinationType === MOVE_ASSET_INTO_HOLDING_PEN;
  }
}
